import { render, staticRenderFns } from "./agreementTurnWarning.vue?vue&type=template&id=18877b9f&"
import script from "./agreementTurnWarning.vue?vue&type=script&lang=js&"
export * from "./agreementTurnWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports